__turbopack_context__.v({
  "container": "review-carousel-module-scss-module__bf99zG__container",
  "overflow-hidden": "review-carousel-module-scss-module__bf99zG__overflow-hidden",
  "review-disclaimer": "review-carousel-module-scss-module__bf99zG__review-disclaimer",
  "scroll-row": "review-carousel-module-scss-module__bf99zG__scroll-row",
});
